import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

/**
 * What the reply guard found in an AI draft. Shown above the reply box so the
 * agent reads it before pressing send.
 */
export default function ReplyIssuesAlert({ issues }) {
  const { t } = useTranslation();

  if (!issues?.length) return null;

  return (
    <div className="mb-3 rounded-lg border border-amber-300 bg-amber-50 p-3">
      <div className="flex items-center gap-2 text-sm font-semibold text-amber-800">
        <AlertTriangle className="h-4 w-4" />
        {t('tickets.reply_issues_title')}
      </div>
      <ul className="mt-1 list-disc pl-6 text-sm text-amber-800">
        {issues.map((issue) => (
          <li key={issue}>{t(`tickets.reply_issue_${issue}`)}</li>
        ))}
      </ul>
    </div>
  );
}
